import { ComponentPropsWithRef } from "react"
import { cn } from "@/lib/utils"

type ContainerProps = ComponentPropsWithRef<"div">

export const Container = ({
  children,
  className,
  ...props
}: ContainerProps) => (
  <div
    {...props}
    className={cn(
      `shadow-loose-plus rounded-xl bg-white py-7 px-6 w-full min-h-[382px] relative`,
      className
    )}
  >
    {children}
  </div>
)

type ScrollableRouteContainerProps = ComponentPropsWithRef<"div">

export const ScrollableRouteContainer: React.FC<
  ScrollableRouteContainerProps
> = ({ children, className, ref, ...props }) => (
  <div
    {...props}
    ref={ref}
    className={cn(
      `w-full px-8 pt-6 pb-32 h-screen overflow-y-auto bg-gray-10`,
      className
    )}
  >
    {children}
  </div>
)

export const LayoutContainer = ({
  children,
  className,
  ...props
}: ContainerProps) => (
  <div
    {...props}
    className={cn(
      `w-full h-screen overflow-y-hidden relative bg-gray-50`,
      className
    )}
  >
    {children}
  </div>
)
